import {
	createVuetify,
} from 'vuetify';
import colors from 'vuetify/lib/util/colors.mjs';
import 'vuetify/dist/vuetify.css';
import {
	de, en, es, fr, nl,
} from 'vuetify/locale';
import {
	VBtn,
	VCol,
	VContainer, VExpansionPanel, VExpansionPanels, VExpansionPanelText, VExpansionPanelTitle, VRow, VTooltip,
} from 'vuetify/components';
import {
	aliases, mdi,
} from 'vuetify/iconsets/mdi-svg';
import {
	mdiAccountGroup,
	mdiAlert,
	mdiBasket,
	mdiBookshelf,
	mdiCalendarToday,
	mdiCashClock,
	mdiClipboardList,
	mdiClipboardTextMultiple,
	mdiCog,
	mdiCreditCard,
	mdiCurrencyEur,
	mdiDatabaseSearch,
	mdiEmail,
	mdiEmailEdit,
	mdiFileChart,
	mdiFileDocument,
	mdiFileDocumentMultiple,
	mdiFileDocumentRemove,
	mdiFileExport,
	mdiFileEye,
	mdiFilePdfBox,
	mdiFinance,
	mdiGavel,
	mdiHammer,
	mdiLightningBolt,
	mdiMagnify,
	mdiOfficeBuilding,
	mdiPiggyBank,
	mdiReceiptText,
	mdiScaleBalance,
	mdiStore,
	mdiTable,
	mdiTestTube,
	mdiTranslateVariant,
	mdiRestore, mdiContentSave,
	mdiArrowDown, mdiArrowLeft, mdiArrowRight, mdiArrowUp,
	mdiAccount, mdiCellphone, mdiCart, mdiWeb, mdiHome,
	mdiStorefront, mdiDotsVertical, mdiCircle,
	mdiChevronLeft, mdiChevronUp, mdiChevronDown, mdiChevronRight,
	mdiInformationSlabSymbol, mdiCheck, mdiCheckBold, mdiExclamation, mdiCalendarWeek,
	mdiMenuDown, mdiMenuUp, mdiPlus, mdiDelete, mdiSquareEditOutline,
	mdiPencil, mdiHelp, mdiSend, mdiFile, mdiCheckCircle,
	mdiLock, mdiCloseCircle, mdiCashMultiple, mdiGauge,
	mdiFileCode, mdiPoll, mdiMenu, mdiClockOutline, mdiCalendar,
	mdiInformation, mdiInformationOutline, mdiMinus,
	mdiCloudUpload, mdiCloudDownload, mdiClose, mdiNoteEdit, mdiSwapHorizontal, mdiMessage, mdiArchive,
	mdiContentCopy, mdiEarth, mdiTranslate, mdiShieldCheck, mdiFileEdit, mdiCardAccountDetails, mdiFileAccount,
	mdiCancel, mdiTimerSand, mdiAutoFix,
	mdiEyeOutline, mdiEyeOffOutline,
} from '@mdi/js';
import {
	VDataTableServer,
	VDataTable,
} from 'vuetify/labs/VDataTable';
import {
	VDatePicker,
	VSkeletonLoader,
} from 'vuetify/labs/components';
import {
	VStepper, VStepperHeader, VStepperItem, VStepperWindow, VStepperWindowItem, VStepperActions,
} from 'vuetify/labs/VStepper';

const Vuetify = {
	install: (app, {
		primary = '#68bd45'
	}) => {
		app.use(createVuetify({
			theme: {
				options: {
					customProperties: true
				},
				themes: {
					light: {
						colors: {
							primary: primary,
							secondary: '#f15a22',
							accent: '#ffe0b2',
							error: colors.red.darken1,
							info: colors.green.darken1,
							success: '#68bd45',
							warning: '#f0ad4e',
							belsimpel: '#009ddf',
						}
					},
				},
			},
			lang: {
				locales: {
					en, nl, de, fr, es
				},
				current: document.documentElement.lang,
			},
			icons: {
				defaultSet: 'mdi',
				aliases: {
					...aliases,
					search: mdiMagnify,
					bookshelf: mdiBookshelf,
					store: mdiStore,
					page: mdiFileDocument,
					pages: mdiFileDocumentMultiple,
					email: mdiEmail,
					emailEdit: mdiEmailEdit,
					pdf: mdiFilePdfBox,
					descriptions: mdiClipboardTextMultiple,
					translate: mdiTranslateVariant,
					translateSmall: mdiTranslate,
					clipboard: mdiClipboardList,
					users: mdiAccountGroup,
					basket: mdiBasket,
					lightning: mdiLightningBolt,
					invoice: mdiReceiptText,
					invoices: mdiCashMultiple,
					gavel: mdiGavel,
					finance: mdiFinance,
					piggyBank: mdiPiggyBank,
					creditCard: mdiCreditCard,
					unprocessedPayment: mdiCashClock,
					calendar: mdiCalendarToday,
					report: mdiFileChart,
					export: mdiFileExport,
					cog: mdiCog,
					hammer: mdiHammer,
					pageViews: mdiFileEye,
					scale: mdiScaleBalance,
					query: mdiDatabaseSearch,
					table: mdiTable,
					terminationLog: mdiFileDocumentRemove,
					building: mdiOfficeBuilding,
					test: mdiTestTube,
					alert: mdiAlert,
					euro: mdiCurrencyEur,
					restore: mdiRestore,
					save: mdiContentSave,
					arrowDown: mdiArrowDown,
					arrowUp: mdiArrowUp,
					arrowLeft: mdiArrowLeft,
					arrowRight: mdiArrowRight,
					user: mdiAccount,
					mobile: mdiCellphone,
					shoppingCart: mdiCart,
					globe: mdiWeb,
					home: mdiHome,
					storeFront: mdiStorefront,
					ellipsisV: mdiDotsVertical,
					circle: mdiCircle,
					chevronLeft: mdiChevronLeft,
					chevronUp: mdiChevronUp,
					chevronDown: mdiChevronDown,
					chevronRight: mdiChevronRight,
					infoSymbol: mdiInformationSlabSymbol,
					check: mdiCheck,
					checkBold: mdiCheckBold,
					exclamation: mdiExclamation,
					question: mdiHelp,
					calendarWeek: mdiCalendarWeek,
					menuDown: mdiMenuDown,
					menuUp: mdiMenuUp,
					plus: mdiPlus,
					minus: mdiMinus,
					bin: mdiDelete,
					squareEdit: mdiSquareEditOutline,
					pencil: mdiPencil,
					send: mdiSend,
					attachment: mdiFile,
					checkCircle: mdiCheckCircle,
					lock: mdiLock,
					closeCircle: mdiCloseCircle,
					cashMultiple: mdiCashMultiple,
					gauge: mdiGauge,
					fileCode: mdiFileCode,
					poll: mdiPoll,
					menu: mdiMenu,
					clockOutline: mdiClockOutline,
					calendarEvent: mdiCalendar,
					info: mdiInformation,
					infoOutline: mdiInformationOutline,
					cloudUpload: mdiCloudUpload,
					cloudDownload: mdiCloudDownload,
					close: mdiClose,
					note: mdiNoteEdit,
					transition: mdiSwapHorizontal,
					message: mdiMessage,
					archive: mdiArchive,
					copy: mdiContentCopy,
					world: mdiEarth,
					insurance: mdiShieldCheck,
					fileEdit: mdiFileEdit,
					cardAccount: mdiCardAccountDetails,
					fileAccount: mdiFileAccount,
					cancel: mdiCancel,
					hourGlass: mdiTimerSand,
					autoFix: mdiAutoFix,
					eye: mdiEyeOutline,
					eyeOff: mdiEyeOffOutline
				},
				sets: {
					mdi
				}
			},
			components: {
				VContainer,
				VDataTableServer,
				VDataTable,
				VSkeletonLoader,
				VStepper,
				VStepperHeader,
				VStepperItem,
				VStepperWindowItem,
				VStepperWindow,
				VStepperActions,
				VRow,
				VCol,
				VBtn,
				VDatePicker,
				VExpansionPanels,
				VExpansionPanel,
				VExpansionPanelTitle,
				VExpansionPanelText,
				VTooltip,
			},
			defaults: {
				VTextField: {
					density: 'compact',
				},
				VSelect: {
					density: 'compact',
				},
				VCombobox: {
					density: 'compact',
				},
				VAutocomplete: {
					density: 'compact'
				},
				VDataTable: {
					density: 'compact',
				},
				VDataTableServer: {
					density: 'compact',
				},
				VTable: {
					density: 'compact',
				}
			},
		}));
	}
};

export default Vuetify;
